export default "__VITE_ASSET__M8bnDMzB__"